(function () {
  'use strict';

  function initAltPurchaseButton(section) {
    var dataEl = section.querySelector('[data-alt-purchase-links]');
    var button = section.querySelector('[data-alt-purchase-button]');
    if (!dataEl || !button) return;

    var links;
    try {
      links = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var labelEl = button.querySelector('[data-alt-purchase-button-label]');
    var defaultLabel = labelEl.textContent;

    function update(variant) {
      var entry = variant ? links[variant.id] : null;

      if (entry && entry.url) {
        button.href = entry.url;
        labelEl.textContent = entry.label || defaultLabel;
        button.style.display = '';
      } else {
        button.style.display = 'none';
      }
    }

    var initialId = button.getAttribute('data-current-variant-id');
    if (initialId) {
      update({ id: initialId });
    }

    document.addEventListener('variant:change', function (evt) {
      update(evt.detail.variant);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-alt-purchase-button]').forEach(function (button) {
      var section = button.closest('.product-section');
      if (section) initAltPurchaseButton(section);
    });
  });
})();